import { connect } from 'react-redux';
import styles from '../../multiLoanDashboard/Dashboard.module.css';
import MainContentPending from '../../pageStructure/mainContentPending';
import PendingView from './pendingView/PendingView';
import OutstandingView from './outstandingView/OutstandingView';
import { SpillBanner } from '../../spill/SpillBanner';
import { RootState } from '@iwProvider/configureStore';
import { OUTSTANDING_STATUS, PENDING_STATUS } from './Dashboard.helpers';
import UnknownView from '../../multiLoanDashboard/UnknownView/UnknownView';
import {
    getAccountId,
    getProductTypeFromURL
} from '../../multiLoanDashboard/accountsSelector';

const mapStateToProps = (state: RootState) => {
    const productType = getProductTypeFromURL();

    return {
        ready: state.revenueBasedLoanDashboard.ready,
        status: state.revenueBasedLoanDashboard.status,
        accountId: getAccountId(state, productType),
        productType
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const LoanView = ({
    status,
    accountId,
    productType
}: {
    status: string;
    accountId: string;
    productType: string;
}) => {
    switch (status) {
        case PENDING_STATUS:
            return <PendingView />;

        case OUTSTANDING_STATUS:
            return (
                <>
                    <SpillBanner />
                    <OutstandingView
                        accountId={accountId}
                        productType={productType}
                    />
                </>
            );

        default:
            return (
                <UnknownView
                    accountId={accountId}
                    // @ts-expect-error productType is being inferred as a string from RootState. Need to type it as a union of strings
                    productType={productType}
                    accountStatus={status}
                />
            );
    }
};

const RevenueBasedLoanDashboard = ({
    ready,
    status,
    accountId,
    productType
}: PropsFromRedux) => {
    if (!ready) {
        return <MainContentPending />;
    }

    return (
        <div
            data-testid="revenue-based-loan-dashboard"
            className={styles.Dashboard}
        >
            <LoanView
                status={status}
                accountId={accountId}
                productType={productType}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RevenueBasedLoanDashboard);
